import React from "react";
import WaitOverlay from "./WaitOverlay";

/** 전역 API 대기 로딩 (App axios interceptor) */
function Loading({
  show,
  text = "처리 중입니다",
  subText = "완료될 때까지 잠시만 기다려 주세요",
  size = "md",
}) {
  return (
    <WaitOverlay
      show={show}
      text={text}
      subText={subText}
      size={size}
      local={false}
    />
  );
}

export default React.memo(Loading);
